export default __webpack_public_path__ + "static/media/copy-green.d51d1fc4.svg";